import { createSelector } from 'reselect'
const namespace = 'orders'

export const getState = state => state[namespace]

export const getAllOrders = createSelector(
  getState,
  state => state.get('list').map(id => state.getIn(['entries', id]))
)

export const getAllEntries = createSelector(
  getState,
  state => state.get('entries')
)

export const findById = id => createSelector(
  getState,
  state => {
    return id && state.getIn(['entries', id])
  }
)

export const loadingStateSelector = createSelector(
  getState,
  state => state.get('loading')
)

export const totalSelector = createSelector(
  getState,
  state => state.get('total')
)
